import * as TypeStyle from 'typestyle';

export enum AlertType {
  Success = 'success',
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
}

export const ColorMap: { [key in AlertType]: {
  accentColor: React.CSSProperties['borderColor'],
  borderColor: React.CSSProperties['borderColor'],
  backgroundColor: React.CSSProperties['backgroundColor'],
  hoverColor: React.CSSProperties['backgroundColor'],
} } = {
  success: {
    accentColor: '#ACE5C8',
    borderColor: '#008057',
    backgroundColor: '#F2F8F6',
    hoverColor: '#E5F1ED',
  },
  info: {
    accentColor: '#D7ECF9',
    borderColor: '#2979B2',
    backgroundColor: '#EEF5FB',
    hoverColor: '#DEEBF3',
  },
  warning: {
    accentColor: '#FBEDA4',
    borderColor: '#FECA56',
    backgroundColor: '#FEF9EF',
    hoverColor: '#FDF3E0',
  },
  error: {
    accentColor: '#F8C7CB',
    borderColor: '#C93A47',
    backgroundColor: '#F9EBEC',
    hoverColor: '#F3D8DA',
  },
};

export const AlertBaseColorStyleName: string = TypeStyle.style({
  $nest: {
    [`&.${AlertType.Success}`]: {
      backgroundColor: ColorMap.success.backgroundColor,
      borderColor: ColorMap.success.borderColor,
    },
    [`&.${AlertType.Info}`]: {
      backgroundColor: ColorMap.info.backgroundColor,
      borderColor: ColorMap.info.borderColor,
    },
    [`&.${AlertType.Warning}`]: {
      backgroundColor: ColorMap.warning.backgroundColor,
      borderColor: ColorMap.warning.borderColor,
    },
    [`&.${AlertType.Error}`]: {
      backgroundColor: ColorMap.error.backgroundColor,
      borderColor: ColorMap.error.borderColor,
    },
  }
});
